let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4Ffqd")).then(() => parcelRequire('bbXii'));